import { mapMutations, mapActions } from 'vuex';

const revertFilesMixin = {
	methods: {
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		...mapActions([
			'revertFileToOrignalByUUID',
			'revertToMetaNotFoundByUUIDList',
		]),

		checkIfFileContainsSpecifiedKey(file, key) {
			if (key in file) {
				return true;
			}
			return false;
		},
		checkIfAnyFileContainsSpecifiedKey(fileList, key = 'originalFileUUID') {
			let keyFound = false;
			for (let file of fileList) {
				if (key in file) {
					keyFound = true;
					break;
				}
			}
			return keyFound;
		},
		revertFilesToMetaNotFound(filesList) {
			if (confirm('Are you sure you want to revert the file/files to Meta?')) {
				this.openLoaderDialog();
				this.revertToMetaNotFoundByUUIDList(filesList).then(() => {
					this.closeLoaderDialog();
					this.fetchDataAfterAPICall();
				});
			}
		},
		revertFileToOrignal(file) {
			if (confirm('Are you sure you want to revert the file to Orignal?')) {
				this.openLoaderDialog();
				this.revertFileToOrignalByUUID(file.uuid).then(() => {
					this.closeLoaderDialog();
					this.fetchDataAfterAPICall();
				});
			}
		},
		revertFilesListToOrignal(filesList, key = 'originalFileUUID') {
			if (
				confirm('Are you sure you want to revert all the files to Orignal?')
			) {
				let filteredFileList = filesList.filter(e => key in e);
				if (!filteredFileList.length) return;
				this.openLoaderDialog(); // Open loader here

				let promiseArray = [];
				for (let file of filteredFileList) {
					promiseArray.push(this.revertFileToOrignalByUUID(file.uuid));
				}
				Promise.all(promiseArray).then(() => {
					this.closeLoaderDialog(); // Close loader here
					this.fetchDataAfterAPICall();
				});
			}
		},
		fetchDataAfterAPICall() {
			// This function needs to be defined in all the components this mixin is imported
		},
	},
};

export default revertFilesMixin;
